import axios from 'axios';
import { convertDateToMonth } from '@/modules/utility';

let pathOfFile = '/resources/report';

if (process.env.PATH_OF_FILE) {
  pathOfFile = process.env.PATH_OF_FILE;
}

function loadDailyReport(date) {
  const month = convertDateToMonth(date);
  return axios.get(`${pathOfFile}/${month}/daily/daily-report-${date}.json`);
}

function loadPrimeTimeDailyReport(date, period = '2h') {
  const month = convertDateToMonth(date);
  return axios.get(`${pathOfFile}/${month}/daily_prime_time/daily_prime_time-${period}-report-${date}.json`);
}


export {
  loadDailyReport,
  loadPrimeTimeDailyReport,
};



// WEBPACK FOOTER //
// ./src/modules/api/report.js